<template>
  <div style="width:100%">
    <div class="radio-form-item__top-content">
      <div>
        <h4>Zulassung durch PKW.de</h4>
        <p class="radio-form-item__price">€ {{ price }} ,- <span class="mwst block">inkl. Mwst.</span></p>
      </div>
      <p>PKW.de lässt das Fahrzeug bei der zuständigen Behörde für mich zu.</p>
    </div>
    <ul class="check-list">
      <li>inkl. 2 Kennzeichenschilder</li>
      <li>inkl. Feinstaubplakette</li>
      <li>inkl. Versandkosten & Amtsgebühren</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['order'],
  computed: {
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
    price() {      
      if (this.commercialBuyer) {
        return this.order.car_info.online_offer_services.all_services_b2b.registration.standard;
      }
      return this.order.car_info.online_offer_services.all_services.registration.standard;
    },
  },
};
</script>
